module.exports = __webpack_public_path__ + "static/media/icon-plane-main.ca9083ae.svg";